/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/skillmacros/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	$(function(){
		var common=__webpack_require__(2);
		var login=__webpack_require__(1);
		common.init();
		login.init();
		$(".m-illustration").niceScroll();
	})

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var login={
		el:$(".m-loginPop"),
		init:function(){
			// var cssFile = getAbsoluteUrl(require('!file!autoprefixer?{browsers: "> 1%"}!less!../css/login.css'));
			// var urs = new URS({
	        //     newCDN: 1,
	        //     version: 3,
	        //     product : 'd21', //【必须】使用的产品ID，如urs
	        //     promark : 'dNvgFOK', //【必须】【申请】申请的组件ID，被分派ID
	        //     host : 'hd.tianyu.163.com',
	        //     productKey: '1bc7680eee080ce2026757eca30d0e53',
	        //     includeBox: 'login',
	        //     needanimation: 0,
	        //     cssDomain: cssFile.replace(/[^\/]+?$/, '').replace('http://','https://'),
	        //     cssFiles: cssFile.match(/([^\/]+?)$/)[1],
	        //     placeholder : { account: '网易通行证' },
	        //     needRegAgreeNoChecked: 1,
	        //     needRegAgreeMbNoChecked: 1,
	        //     needClause: 1,
	        //     clause: 0
	        // });
	
	        // urs.logincb = urs.regcb = function (urs) {
	        //     window.location.reload();
	        // };
	
	        nie.define('login', function() {
	            var Login = nie.require('nie.util.login2');
	            window.Login = Login
	            var example = Login.create({
	                holder: '#login',
	                success: function (params) {
	                    window.location.reload();
	                }
	            });
	        })
	
	        var self=this;
	        this.el.find(".closeBtn").click(function(){
	            self.close();
	        })
	
	        $(".logoutBtn").attr("href","http://reg.163.com/Logout.jsp?username="+urs+"&url=" + window.location.href);
		    $(".loginBtn").click(function(){
	            self.show();
	        })
	    },
	    close:function(){
	        this.el.fadeOut();
	    },
	    show:function(){
	        this.el.fadeIn();
	    }
	}
	
	function getAbsoluteUrl (url) {
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	
	module.exports = login;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var common={
		commonPopEl:$(".m-commonPop"),
		commonCallback:null,
		confirmPopEl:$(".m-commonPop"),
		sideEl:$(".m-side"),
		init:function(){
			var _this=this;
			this.commonPopEl.find(".confirmBtn").click(function(){
				_this.commonPopEl.hide();
				if(_this.commonCallback){
					_this.commonCallback();
				}
			})
			this.sideEl.find(".switchBtn").click(function(){
				if(_this.sideEl.hasClass("close")){
					_this.sideEl.removeClass("close");
				}else{
					_this.sideEl.addClass("close");
				}
				
			})
			$(".m-side-close").click(function(){
				_this.sideEl.removeClass("close");
			})
		},
		getQueryString:function(name){
			var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		    var r = window.location.search.substr(1).match(reg);
		    if(r!=null)return  unescape(r[2]); return null;
		},
		showCommonPop:function(info){
			this.commonPopEl.find(".info").html(info);
			this.commonPopEl.show();
		},
		toDecimal:function(x) {  
	        var f = parseFloat(x);  
	        if (isNaN(f)) {  
	            return false;  
	        }  
	        var f = Math.round(x*100)/100;  
	        var s = f.toString();  
	        var rs = s.indexOf('.');  
	        if (rs < 0) {  
	            rs = s.length;  
	            s += '.';  
	        }  
	        while (s.length <= rs + 1) {  
	            s += '0';  
	        }  
	        return s;  
	    } 
	}
	
	Handlebars.registerHelper('date', function(timestamp) {
		var date=new Date(timestamp);
		return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
	});
	
	Handlebars.registerHelper('tuijianFormat', function(tuijian) {
		if(tuijian==0){
			return "暂无";
		}
	
		return common.toDecimal(tuijian)+"分";
	});
	
	Handlebars.registerHelper('tag', function(tagStr) {
		if(tagStr==""||tagStr==null){
			return "";
		}
		var tagObj=JSON.parse(tagStr);
		if(tagObj.type==0){
			return "PVP";
		}else{
			return "PVE";
		}
	});
	
	Handlebars.registerHelper('starFormat', function(tuijian) {
		if(tuijian==0){
			return "暂无";
		}
		tuijian=common.toDecimal(tuijian);
		var starCount=tuijian/2;
		var floor=Math.floor(starCount);
		var ceil=Math.round(starCount);
		var html='';
		for(var i=0;i<floor;i++){
			html+='<i class="star"></i>';
		}
		if(ceil>floor){
			html+='<i class="star half"></i>';
		}
		return html;
	});
	
	module.exports=common;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// illustration.js